import React from 'react'
import star_icon from '../../assets/images/icons/star-icon.png'





const index = (props)=>{
    return(
        <div className="dashboard-textfield-container mt-4">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                </div>}
            </div>
            <div className="dashboard-textfield-input" style={{border: 'none'}}>
            <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
                onChange={props.handleChange}
                value={props.value}
                type={props.text}
            />
            </div>
        </div>

    )
}

export default index